import React from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const IconLlmX = React.forwardRef<SVGSVGElement, any>((props, ref) => {
  return (<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" className="icon-llm-x" data-icon="icon-llm-x" aria-hidden="true" {...props} ref={ref}><path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeLinecap="square" strokeLinejoin="round"/></svg>);
});

IconLlmX.displayName = 'IconLlmX';
